module.exports = __webpack_public_path__ + "media/application/images/icons/pin-purple-68427d85b6c0b6af2f3119e6412a9be3.svg";